export default {
  init() {
    // JavaScript to be fired on all pages

    const $hamburger = $('.hamburger');
    const $header = $('.header');
    const $body = $('body');

    $hamburger.on('click', () => {
      $header.toggleClass('nav-open');
      $body.toggleClass('nav-open');
    });

    const $slider = $('.slider-content');
    $slider.slick({
      mobileFirst: true,
      prevArrow: $('.slider-button-prev'),
      nextArrow: $('.slider-button-next'),
      variableWidth: true,
    });

    const pop_outs = $('a.open-in-popout');
    pop_outs.on('click', function(e) {
      e.preventDefault();
      let $this = $(this);
      let width = $this.data('width') || 600;
      let height = $this.data('height') || 600;
      window.open(
        $this.attr('href'),
        'popup',
        `width=${width}, height=${height}`
      );
    });

    const $mobile_cat_drop = $('.mobile-cat-drop');
    if ($mobile_cat_drop.length > 0) {
      $mobile_cat_drop.on('change', function() {
        let $this = $(this);
        let val = $this.val();
        if (val != 0) {
          window.location.href = '/stash/category/' + val;
        } else {
          window.location.href = '/stash/';
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js